import store from "src/Reducers/store";
import * as appActions from "src/Actions/appActions";

const setCurrentPage = (pageIndex: number) => store.dispatch(appActions.setCurrentPage(pageIndex));

export default setCurrentPage;
